import { Controller } from 'react-hook-form';
import { Alert, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { RichTextEditor } from '~/commonComponents';
import { jobDescriptionMinLength } from '~/components/PermanentJobsV2/utils';
import { IBaseFormProps } from '../../Types';

interface IJobDescriptionFormProps extends IBaseFormProps {
  showBanner?: boolean;
  disabled?: boolean;
}

export const JobDescriptionForm = ({
  control,
  errors,
  showBanner,
  disabled,
}: IJobDescriptionFormProps) => {
  return (
    <Column gap={2}>
      {showBanner && (
        <Alert
          severity="info"
          description="We created this for you based on the details you've provided."
        />
      )}
      <Controller
        control={control}
        name="jobDescription"
        render={({ field }) => (
          <RichTextEditor
            value={field.value}
            onChange={field.onChange}
            height={350}
            toolbarOptions={['bold', 'italic']}
            htmlPlaceholder="<b>Overview</b><br/>Give an overview of the job and general expectations.<br/><br/><b>Responsibilities</b><ul><li>Outline what kinds of responsibilities/tasks will be required from the role.</li></ul><br/><b>Why Work with Us?</b><br/>Talk about what makes your office a great place to work!"
            isError={!!errors?.jobDescription}
            dataCy="perm-job-description-editor"
            disabled={disabled}
          />
        )}
      />
      <Typography italic color={colors.neutral[500]}>
        {jobDescriptionMinLength} Character Min
      </Typography>
    </Column>
  );
};
